import type { ButtonHTMLAttributes, ReactNode } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

export function IconButton({ className = "", children, ...rest }: Props) {
  return (
    <button className={`icon-btn ${className}`.trim()} {...rest}>
      {children}
    </button>
  );
}
